import { makeStyles } from '@material-ui/core/styles';
import { TextColors, SecondaryColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  card: {
    color: TextColors.light,

    '& $contentCategory': {
      color: SecondaryColors.main,
    },
    '& $copy': {
      color: hexToRGBA(TextColors.light, TextOpacities.light1),
    },
  },
};

const lightTheme = {
  card: {
    color: TextColors.dark,

    '& $contentCategory': {
      color: SecondaryColors.dark,
    },
    '& $copy': {
      color: hexToRGBA(TextColors.dark, TextOpacities.light1),
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    card: {
      '&.dark-theme': darkTheme.card,
      '&.light-theme': lightTheme.card,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
    },
    cardLogo: {
      maxHeight: '65px',

      '&:not(:last-child)': {
        marginBottom: muiTheme.spacing(4),
      },

      '& img': {
        height: '100%',
        maxHeight: '65px',
        width: 'auto',
      },
    },
    content: {
      '&.MuiCardContent-root': {
        padding: muiTheme.spacing(2.5, 4),
        flexGrow: 1,

        '&:first-child': {
          paddingTop: muiTheme.spacing(4),

          [muiTheme.breakpoints.up('md')]: {
            paddingTop: muiTheme.spacing(5.5),
          },
        },

        '&:not(:first-child)': {
          paddingTop: 0,
        },

        '&:last-child': {
          paddingBottom: muiTheme.spacing(4),
        },

        '&:not(:last-child)': {
          paddingBottom: muiTheme.spacing(3),
        },
      },
    },
    contentCategory: {
      '&.MuiTypography-root': {
        ...muiTheme.typography.overline,
        marginBottom: muiTheme.spacing(1),
      },
    },
    actions: {
      '&.MuiCardActions-root': {
        padding: muiTheme.spacing(0, 4, 4),

        '& > *': {
          position: 'relative',
          zIndex: 2,
        },
      },
    },
    image: {
      // '&:not(:first-child)': {
      //   marginTop: muiTheme.spacing(2.5),
      // },

      '&:not(:last-child)': {
        marginBottom: muiTheme.spacing(4),
      },
    },
    contentHeading: {
      '&.MuiTypography-root': {
        color: 'inherit',
        marginBottom: muiTheme.spacing(1.5),
      },
    },
    copy: {},
    cardLink: {
      '&.MuiButtonBase-root': {
        position: 'absolute',
        width: '100%',
        height: '100%',
        zIndex: 1,
      },
    },
    cardActionsLink: {
      '&.MuiButtonBase-root': {
        position: 'relative',
        zIndex: 2,
      },
    },
  }),
  { name: 'GenCardListSingleContentCard' },
);

export default useStyles;
